import PxPopoverTransportador from './PxPopoverTransportador.vue';

export default { /* eslint-disable no-param-reassign */
  install(Vue, options) {
    const pxOptions = {
      isComprador: options.type === 'COMPRADOR',
      isFornecedor: options.type === 'FORNECEDOR',
      uploadFilePath: 'files',
    };

    Vue.$pxFrete = pxOptions;
    Vue.prototype.$pxFrete = pxOptions;

    Vue.component('PxPopoverTransportador', PxPopoverTransportador);
  },
};
